// extracted by mini-css-extract-plugin
export var chevronIcon = "_ap-2";
export var teamName = "_ap-1";
export var teamSwitcherButton = "_ap-0";